import { mobileLargeMax, mobileXLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import faqHeaderPn from '@propertypal/shared/src/resources/bg/faq-header-pn.png';
import faqHeader from '@propertypal/shared/src/resources/bg/faq-header.jpg';
import platform from '@propertypal/shared/src/utils/platform';
import styled from 'styled-components';
import { Box } from '../layout';
import { MidHeading } from '../typography';

export const FaqContainer = styled.section`
  background: ${({ theme }) => theme.backgroundLightest};
  padding-bottom: 40px;
`;

export const Logo = styled.img`
  width: ${platform.select(136, 240)}px;
  height: ${platform.select(49, 33)}px;
  cursor: pointer;
`;

export const FaqHeaderContainer = styled.div`
  padding: 25px 20px;
  background: ${({ theme }) => theme.white};
  border-bottom: solid 1px ${({ theme }) => theme.backgroundLighter};
`;

export const FaqHeaderWrapper = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  max-width: 1440px;
  margin: 0 auto;

  @media (${platform.select(mobileXLargeMax, tabletMax)}) {
    ${MidHeading} {
      font-size: 16px;
    }

    ${Logo} {
      width: ${platform.select(102, 150)}px;
      height: ${platform.select(36, 21)}px;
    }
  }

  @media (${mobileLargeMax}) {
    flex-direction: column;

    ${Box} {
      text-align: center;
    }
  }
`;

export const FaqHeaderBg = styled.div`
  background-image: url(${platform.select(faqHeader, faqHeaderPn).src});
  background-size: cover;
  background-position: center;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
